/* The receipt a reviewer is attesting. Tokens only (ADR-0007). A scope colour never tints the figure:
   an emissions total is not good or bad news. */

.attest {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.figure {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 10px;
  margin: 0;
}

.value {
  color: var(--ink);
  font-size: var(--t-kpi);
  line-height: 1.05;
  font-variant-numeric: lining-nums tabular-nums;
}

.unit {
  color: var(--ink-2);
  font-size: var(--t-body);
  font-weight: 600;
}

.scope {
  color: var(--muted);
  font-size: var(--t-dense);
  text-transform: capitalize;
}

.superseded {
  margin: 0;
  padding: 1px 0 1px 10px;
  border-left: 2px solid var(--warn);
  color: var(--ink-2);
  font-size: var(--t-min);
}

.chainHead {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 10px;
  margin: 4px 0 0;
  color: var(--ink);
  font-size: var(--t-head);
  font-weight: 650;
}

.chainCount {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 500;
}

.chain {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--line);
}

.link {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 2px 10px;
  padding: 7px 0;
  border-bottom: 1px solid var(--line);
  font-size: var(--t-dense);
}

.label {
  color: var(--ink);
  font-weight: 600;
}

.reason {
  grid-column: 2;
  color: var(--muted);
  font-size: var(--t-min);
  overflow-wrap: anywhere;
}

.open {
  align-self: flex-start;
  min-height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 650;
  cursor: pointer;
}

.open:hover {
  background: var(--panel-2);
}

.open:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

@media (max-width: 560px) {
  .open {
    min-height: var(--target-touch);
  }
}
